import { mailApiGet, mailApiPost } from "@/lib/api/client";
import type {
  MailContactGroup,
  MailContactGroupSavePayload,
} from "@/lib/types/contactGroup";

export function fetchMailContactGroups(params?: { q?: string; limit?: number }) {
  const qs = new URLSearchParams();
  if (params?.q?.trim()) qs.set("q", params.q.trim());
  if (params?.limit) qs.set("limit", String(params.limit));
  const query = qs.toString();
  return mailApiGet<{ success: boolean; groups: MailContactGroup[] }>(
    `contacts/groups/list.php${query ? `?${query}` : ""}`
  );
}

export function saveMailContactGroup(payload: MailContactGroupSavePayload) {
  return mailApiPost<{ success: boolean; group: MailContactGroup }>(
    "contacts/groups/save.php",
    payload
  );
}

export function deleteMailContactGroup(id: number) {
  return mailApiPost<{ success: boolean }>("contacts/groups/delete.php", { id });
}
